/**
 * Created by Administrador on 9/30/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {

        $stateProvider
            .state('changePassword', {
                parent: 'app',
                url: '/profileUser/changePassword',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/profileUser/changePassword/changePassword.html',
                        controller: 'changePasswordCtrl',
                        controllerAs: 'vm',
                        resolve:{
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['changePassword']);
                            }]
                        }
                    }
                }
            });
    }
})();
